import { FormSetEnum } from '../../../types/src/services/enum/form-set.enum';
import { JsonObject } from '@angular-devkit/core';
import {
    biKeys,
    deknKeys,
    esasKeys,
    iadlKeys,
    msseKeys,
    niKeys,
    rvdKeys,
} from '@libs/shared/form-helpers/forms/forms-json-keys';

export class FormsTotalPoints {

    public static get(formData: string, formSetType: string): number {
        const formDataJson = JSON.parse(formData);
        switch(formSetType) {
            case FormSetEnum.BI:
                return this.getForBi(formDataJson);
            case FormSetEnum.DEKN:
                return this.getForDekn(formDataJson);
            case FormSetEnum.ESAS:
                return this.getForEsas(formDataJson);
            case FormSetEnum.IADL:
                return this.getForIadl(formDataJson);
            case FormSetEnum.MSSE:
                return this.getForMsse(formDataJson);
            case FormSetEnum.NI:
                return this.getForNi(formDataJson);
            case FormSetEnum.PPS:
                return this.getForPps(formDataJson);
            case FormSetEnum.RVD:
                return this.getForRvd(formDataJson);
            default:
                return 0;
        }
    }

    public static getForBi(formData: JsonObject): number {
        return biKeys.reduce((acc, key) => acc + Number(formData[key] || 0), 0);
    }

    public static getForDekn(formData: JsonObject): number {
        return deknKeys.reduce((acc, key) => acc + Number(formData[key] || 0), 0);
    }

    public static getForEsas(formData: JsonObject): number {
        return esasKeys.reduce((acc, key) => acc + Math.max(Number(formData[key] || 0), 0), 0);
    }

    public static getForIadl(formData: JsonObject): number {
        return iadlKeys.reduce((acc, key) => acc + Number(formData[key] || 0), 0);
    }

    public static getForMsse(formData: JsonObject): number {
        return msseKeys.reduce((acc, key) => acc + Number(Boolean(formData[key])), 0);
    }

    public static getForNi(formData: JsonObject): number {
        return niKeys.reduce((acc, key) => acc + Number(formData[key] || 0), 0);
    }

    public static getForPps(formData: JsonObject): number {
        return Number(formData.ppsValue);
    }

    public static getForRvd(formData: JsonObject): number {
        return rvdKeys.reduce((acc, key) => acc + Number(formData[key] || 0), 0);
    }
}
